module.exports = __webpack_public_path__ + "static/img/20005D_3_4_R_20220623_LC.4c27285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20005D_3_4_R_20220623_LC.png
// module id = HHLr
// module chunks = 0